// api/services/acknowledgements.ts
import { handleRequest } from '@/api';

export interface AcknowledgementsMap {
    [key: string]: string;
}

export const getAcknowledgements = (): Promise<AcknowledgementsMap> =>
    handleRequest<AcknowledgementsMap>('get', '/users/me/acknowledgements', {}, null, false);

export const setAcknowledgement = (key: string, value: string = 'true'): Promise<void> =>
    handleRequest<void>('post', '/users/me/acknowledgements', { key, value });
